import { render, staticRenderFns } from "./Picture.vue?vue&type=template&id=8a5de674&scoped=true"
import script from "./Picture.vue?vue&type=script&lang=js"
export * from "./Picture.vue?vue&type=script&lang=js"
import style0 from "./Picture.vue?vue&type=style&index=0&id=8a5de674&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5de674",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Picture: require('/vercel/path0/components/elements/Picture.vue').default})
